import { render, staticRenderFns } from "./StrategyImageTile.vue?vue&type=template&id=08cf4c24&scoped=true"
import script from "./StrategyImageTile.vue?vue&type=script&lang=js"
export * from "./StrategyImageTile.vue?vue&type=script&lang=js"
import style0 from "./StrategyImageTile.vue?vue&type=style&index=0&id=08cf4c24&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cf4c24",
  null
  
)

export default component.exports